module.exports = __webpack_public_path__ + "static/media/Slide18.90ae0ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide18.png
// module id = 1640
// module chunks = 0